import { ArtistType as ApiArtistType } from 'src/api/generated/touring/types';
import { mapCompanyContactType, mapLinkableEntityType } from '../common';
import { mapBankAccountType } from '../mapBankAccountType';
import { mapArtistFestivalType, mapArtistTourType } from './helpers';
import { ArtistType } from './types';

export const mapArtistType = (apiArtist: ApiArtistType): ArtistType => {
  return {
    id: apiArtist.id,
    name: apiArtist.name,
    abbreviation: apiArtist.abbreviation ?? null,
    website: apiArtist.website ?? null,
    artistLink: apiArtist.artistLink ?? null,
    genre: apiArtist.genre,
    isDomesticArtist: apiArtist.isDomesticArtist,
    isFemaleAct: apiArtist.isFemaleAct,
    comment: apiArtist.comment,
    agent: apiArtist.agent ? mapCompanyContactType(apiArtist.agent) : null,
    buyer: apiArtist.buyer ? mapCompanyContactType(apiArtist.buyer) : null,
    manager: apiArtist.manager
      ? mapCompanyContactType(apiArtist.manager)
      : null,
    productManager: apiArtist.productManager
      ? mapCompanyContactType(apiArtist.productManager)
      : null,
    projectLead: apiArtist.projectLead
      ? mapCompanyContactType(apiArtist.projectLead)
      : null,
    coordinator: apiArtist.coordinator
      ? mapCompanyContactType(apiArtist.coordinator)
      : null,
    defaultOrganizationUnit: apiArtist.defaultOrganizationUnit ?? null,
    tours: apiArtist.tours.map(mapArtistTourType),
    festivals: apiArtist.festivals.map(mapArtistFestivalType),
    contractingPartyPersons: apiArtist.contractingPartyPersons.map(
      mapLinkableEntityType
    ),
    contractingPartyCompanies: apiArtist.contractingPartyCompanies.map(
      mapLinkableEntityType
    ),
    bankAccounts: apiArtist.bankAccounts.map(mapBankAccountType),
  };
};
